<template>
	<footer class="site-footer">
		<div class="container">
			<div class="top">
				<RouterLink to="/" class="brand">
					<img :src="clubLogo" alt="Karate klub Bregana" class="brand-logo" />
					<span>{{ contact.clubName }}</span>
				</RouterLink>

				<nav class="links" aria-label="Podnožje">
					<RouterLink to="/about">O nama</RouterLink>
					<RouterLink to="/schedule">Raspored</RouterLink>
					<RouterLink to="/gallery">Galerija</RouterLink>
					<RouterLink to="/results">Rezultati</RouterLink>
					<RouterLink to="/contact">Kontakt</RouterLink>
				</nav>

				<div class="socials">
					<a v-for="social in socials" :key="social.url" :href="social.url" target="_blank" rel="noopener noreferrer">
						{{ social.label }}
					</a>
				</div>
			</div>

			<div class="bottom">
				<span>{{ contact.address.street }}, {{ contact.address.postalCode }} {{ contact.address.city }}</span>
				<span>© {{ year }} {{ contact.clubName }}</span>
			</div>
		</div>
	</footer>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { contact, socials } from '../content/contact.js'
import clubLogo from '../assets/images/club-logo.png'

const year = new Date().getFullYear()
</script>

<style lang="scss" scoped>
.site-footer {
	border-top: 1px solid var(--color-border);
	margin-top: var(--section-spacing);
}

.container {
	padding-block: 2.5rem;
}

.top {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 1.5rem;
	padding-bottom: 1.5rem;
	border-bottom: 1px solid var(--color-border);
}

.brand {
	display: flex;
	align-items: center;
	gap: 0.6rem;
	color: var(--color-text);
	font-family: var(--font-heading);
	font-weight: 700;
	font-size: 0.9rem;
	text-transform: uppercase;
	letter-spacing: 0.03em;
}

.brand-logo {
	width: 32px;
	height: 32px;
	border-radius: 50%;
}

.links {
	display: flex;
	flex-wrap: wrap;
	gap: 1.25rem;

	a {
		color: var(--color-text-muted);
		font-size: 0.85rem;

		&:hover {
			color: var(--color-accent);
		}
	}
}

.socials {
	display: flex;
	gap: 0.6rem;

	a {
		padding: 0.4rem 0.9rem;
		border: 1px solid var(--color-border);
		border-radius: 999px;
		color: var(--color-text-muted);
		font-size: 0.8rem;

		&:hover {
			border-color: var(--color-accent);
			color: var(--color-accent);
		}
	}
}

.bottom {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	gap: 0.5rem;
	padding-top: 1.25rem;
	color: var(--color-text-muted);
	font-size: 0.8rem;
}
</style>
